export class PriceUtils {
	static currencies = {
		'USD': '$'
	}

	static priceString(price) {
		return `${price.currency}${price.amount}`
	}
}
